import { useCallback, useState } from 'react'
import { Maybe } from 'types/graphqlTypes'
import { useModalState } from 'utils/hooks/useModalState'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'

interface IUseSavedLaneModalsState {
  selectedSavedLane: Maybe<LaneAlert>
  isAddEditModalOpen: boolean
  isDeleteModalOpen: boolean
  openAddModal: () => void
  openEditModal: (savedLane: LaneAlert) => void
  openDeleteModal: (savedLane: LaneAlert) => void
  closeModals: () => void
}

export const useSavedLaneModals = (): IUseSavedLaneModalsState => {
  const [selectedSavedLane, setSelectedSavedLane] = useState<Maybe<LaneAlert>>(null)

  const { createToggleHandler, modalState } = useModalState({
    savedLaneModal: false,
    deleteConfirmationModal: false,
  })
  const { deleteConfirmationModal: isDeleteModalOpen, savedLaneModal: isAddEditModalOpen } =
    modalState || {}

  const openAddModal = useCallback(() => {
    createToggleHandler('savedLaneModal', true)()
  }, [createToggleHandler])

  const openEditModal = useCallback(
    (savedLane: LaneAlert) => {
      setSelectedSavedLane(savedLane)
      openAddModal()
    },
    [openAddModal]
  )

  const openDeleteModal = useCallback(
    (savedLane: LaneAlert) => {
      setSelectedSavedLane(savedLane)
      createToggleHandler('deleteConfirmationModal', true)()
    },
    [createToggleHandler]
  )

  const closeModals = useCallback(() => {
    createToggleHandler('savedLaneModal', false)()
    createToggleHandler('deleteConfirmationModal', false)()
    setSelectedSavedLane(null)
  }, [createToggleHandler])

  return {
    selectedSavedLane,
    isAddEditModalOpen,
    isDeleteModalOpen,
    openAddModal,
    openEditModal,
    openDeleteModal,
    closeModals,
  }
}
